export const menuData = [
  {
    label: "Home",
    href: "/",
    iconClass: "",
    className: "active menu-thumb",
  },
  {
    label: "About Us",
    href: "/about",
  },
  // {
  //   label: "Water Activities",

  //   href: "/water-activities",
  //   iconClass: "fa-regular fa-angle-down",
  //   className: "has-dropdown",
  //   submenu: [
  //     { label: "Water World Packages", href: "/packages" },
  //     { label: "Attraction Packages", href: "#" },
  //   ],

  // },
  {
    label: "Water Activities",
    href: "/home/water-activities",
  },
  {
    label: "Event Centres",
    href: "/event-centres",
  },
  {
    label: "Cinema",
    href: "/cinema",
  },
  {
    label: "E Games",
    href: "/e-games",
    // iconClass: "fa-regular fa-angle-down",
    // submenu: [
    //   { label: "Birthday Parties", href: "/events/birthday-parties" },
    //   { label: "Family Get Together Parties", href: "#" },
    //   { label: "Anniversary Celebrations", href: "#" },
    // ],
  },
  {
    label: "Guest Rooms",
    href: "/guest-rooms",
    iconClass: "",
  },
  // {
  //   label: "Gallery",
  //   href: "/gallery",
  //   iconClass: "",
  // },
  {
    label: "Contact Us",
    href: "/contact",
  },
];

export const onepageLinks = [
  { href: "#about", text: "About Us" },
  { href: "#services", text: "Services" },
  { href: "#projects", text: "Projects" },
  { href: "#team", text: "Team" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];

export const footerLinks = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Packages", href: "/packages/school-packages" },
  { name: "E-Games", href: "/e-games" },
  { name: "Cinema", href: "/cinema" },
  { name: "Guest Rooms", href: "/guest-rooms" },
  { name: "Gallery", href: "/gallery" },
  { name: "Careers", href: "/careers" },
  { name: "Contact Us", href: "/contact" },
];
